export default __webpack_public_path__ + "static/media/background.80d3d199.jpg";